import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AdminService } from '../../../../services/admin.service';

@Component({
    selector: 'app-daily-update-run-command',
    imports: [CommonModule, ButtonModule],
    templateUrl: './daily-update-run-command.component.html',
    styleUrl: './daily-update-run-command.component.scss'
})
export class DailyUpdateRunCommandComponent implements OnInit {
  onLoadMessage = '	This update command relies on an external application and may require several minutes to process. If the next page does not appear (ie. Page Not Found), simply click the back button and then get back to the Admin Overview page';
  updateComplete = false;
  systemMessage = '';
  isLoading = false;
  constructor(
    private router: Router,
    private adminService: AdminService
  ) { }

  ngOnInit(): void {
    // this.getDailyUpdateSystemMessage();
  }

  // getDailyUpdateSystemMessage(): void {
  //   this.isLoading = true;

  //   this.adminService.getDailyUpdateSystemMessage().subscribe({
  //     next: (response) => {
  //       if (response && response.result) {
  //         this.systemMessage = response.result;
  //       } else if (response && typeof response === 'string') {
  //         // Handle case where response itself is a string
  //         this.systemMessage = response;
  //       } else {
  //         // Fallback message if no result property is found
  //         this.systemMessage = 'This update command relies on an external application and may require several minutes to process.';
  //       }
  //       this.isLoading = false;

  //     },
  //     error: (error) => {
  //       console.error('Error fetching system message:', error);
  //       // Set a default message in case of error
  //       this.systemMessage = 'This update command relies on an external application and may require several minutes to process.';
  //       this.isLoading = false;
  //     }
  //   });
  // }

  runUpdate(): void {
    this.isLoading = true;
    // Here you would implement the actual API call to run the update process

    // Simulate processing time
    // In a real implementation, you would call a service method that returns an Observable
    setTimeout(() => {
      this.updateComplete = true;
      this.isLoading = false;
    }, 1000);
  }
}
